var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecApplied({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3057 8.85943C12.9473 7.21272 12.9473 4.54288 11.3057 2.89617C9.66417 1.24946 7.00264 1.24946 5.36106 2.89617C3.71948 4.54288 3.71948 7.21272 5.36106 8.85943C7.00264 10.5061 9.66417 10.5061 11.3057 8.85943Z",
    fill: "#23242A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3373 10.725C6.5747 10.725 4.88429 11.4274 3.63794 12.6776C2.39159 13.9279 1.69141 15.6236 1.69141 17.3917C1.69141 17.637 1.78855 17.8723 1.96148 18.0457C2.13441 18.2192 2.36898 18.3167 2.61354 18.3167H14.1026C14.3472 18.3167 14.5817 18.2192 14.7547 18.0457C14.9276 17.8723 15.0247 17.637 15.0247 17.3917C15.0247 16.5127 14.8515 15.6423 14.5149 14.8308C14.1783 14.0192 13.6851 13.2824 13.0635 12.6628C12.442 12.0432 11.7044 11.553 10.8933 11.2205C10.0822 10.8879 9.21354 10.7195 8.3373 10.725Z",
    fill: "#23242A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4 7.68302C18.6441 7.92709 18.6441 8.32282 18.4 8.5669L15.0667 11.9002C14.8226 12.1443 14.4269 12.1443 14.1828 11.9002L12.5161 10.2336C12.2721 9.98949 12.2721 9.59376 12.5161 9.34968C12.7602 9.10561 13.156 9.10561 13.4 9.34968L14.6248 10.5744L17.5161 7.68302C17.7602 7.43894 18.156 7.43894 18.4 7.68302Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecApplied);
export default __webpack_public_path__ + "static/media/rec-applied.5e9f92f1fb38a9ea8cb44adf760ae251.svg";
export { ForwardRef as ReactComponent };